import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { HTTP } from '@ionic-native/http/ngx';
import { NativeAudio } from '@ionic-native/native-audio/ngx';
import { Platform } from '@ionic/angular';
import { File, FileEntry } from '@ionic-native/file/ngx';
import { Media } from '@ionic-native/media/ngx';

import { take } from 'rxjs/operators';

import { ExerciseProviderService } from '../../services/exercise-provider.service'
import { ContentProviderService } from '../../services/content-provider.service'

@Component({
  selector: 'app-review',
  templateUrl: './review.page.html',
  styleUrls: ['./review.page.scss'],
})
export class ReviewPage implements OnInit {

  id: string;
  lection: string;

  oral: any;
  written: any;

  progress = {
    oral:{
      correct:0,
      fails:0,
      total:0
    },
    written:{
      correct:0,
      fails:0,
      total:0
    }
  }

  readonly MAX_REACTION = 6000;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private nativeAudio: NativeAudio,
    private platform: Platform,
    private http: HTTP,
    private file: File,
    public exerciseProvider: ExerciseProviderService,
    public contentProvider: ContentProviderService,
    private media: Media
  ) {
    this.route.params.subscribe(params => {
      console.log(params)
      this.id = params['id'];
      this.lection = params['lection'];
      this.exerciseProvider.fetchReview(this.id);
      this.exerciseProvider.setId(this.id);
      this.exerciseProvider.getProgress().subscribe(progress => {
        console.log(progress)
        this.progress = progress;
      })
      this.exerciseProvider.getReview().subscribe(review => {
        this.oral = [];
        this.written = []
        console.log(review)
        for (let e of review){
          if (e['action']=='oral'){
            e['downloaded'] = false;
            e['downloading'] = false;
            this.oral.push(e)
          } else {
            this.written.push(e)
          }
        }
      })
    });
  }

  ngOnInit() {
    this.oral = [];
    this.written = []
  }

  goHome(){
    this.router.navigate(['/']);
  }

  goToExercises(){
    this.router.navigate(['/exercises', {
      'id': this.id,
      exercises: true,
      lection: this.lection
    }]);
  }

  playMediaFile(audioPath){
    let mediaFile = this.media.create(audioPath);
    mediaFile.onStatusUpdate.subscribe(status => {
      if (status == 4){
        mediaFile.release();
      }
    });
    mediaFile.play();
  }

  playRecording(index){
    const audioFile = this.oral[index].audio;
    const audioPath = this.file.dataDirectory + audioFile;

    if (!this.oral[index].downloaded){
      this.oral[index].downloading = true;
      this.exerciseProvider.getAudioURL(audioFile).pipe(take(1)).subscribe(url => {
        console.log("d: ", this.oral[index].downloading)
        this.http.downloadFile(
          url,
          { id: '12', message: 'test' },
          { Authorization: 'OAuth2: token' },
          audioPath
        ).then(
          response => {
            this.oral[index].downloading = false;
            this.oral[index].downloaded = false;
            this.playMediaFile(audioPath)
          },
          error => {
            this.oral[index].downloading = false;
          }
        )
      });
    } else {
      this.playMediaFile(audioPath);
    }
  }

}
